export default "__VITE_ASSET__1d18e455__"